<template>
    <div class="vue_flex vue_column">
        <div class="cont_wrapper">
            <div class="cont_wrapper_sx">
                <div class="shaixuan_left">
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/tjsj@2x.png" alt="" />
                            <div class="shaixuan_item_tit">统计时间</div>
                        </div>
                        <el-date-picker v-model="listQuery.time" type="datetimerange" range-separator=""
                            start-placeholder="" end-placeholder="" value-format="timestamp">
                        </el-date-picker>
                    </div>
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/qd@2x.png" alt="" />
                            <div class="shaixuan_item_tit">渠道</div>
                        </div>
                        <el-select v-model="listQuery.type" placeholder="请选择" class="vue_flex_item">
                            <el-option v-for="item in qudaooptions" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/dp@2x.png" alt="" />
                            <div class="shaixuan_item_tit">店铺</div>
                        </div>
                        <el-select v-model="listQuery.shopid" placeholder="请选择" class="vue_flex_item">
                            <el-option v-for="item in dpList" :key="item.shopid" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="shaixuan_btns">
                    <div class="shaixuan_btn1 h" @click="qingchu">清除</div>
                    <div class="shaixuan_btn2 h" @click="getList">查询</div>
                </div>
            </div>
            <div class="home_title">
                <div class="home_tit">综合指标</div>
                <!-- <div class="home_right">
          <div class="home_right_1">
            <div>日</div>
            <img src="../../../../../assets/ym/xl@2x.png" alt="" />
          </div>
          <img
            class="home_right_2"
            src="../../../../../assets/ym/gd@2x.png"
            alt=""
          />
        </div> -->
            </div>

            <linkboxs :list="linkList" @itemClick="linkboxsClick"></linkboxs>

            <div id="myChart"></div>

            <div class="home_title">
                <div class="home_tit">{{ tableTit }}明细表</div>
            </div>

            <el-table :data="tableData" style="width: 100%"
                :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }">
                <el-table-column fixed prop="goodsid" label="商品ID" align="center"></el-table-column>
                <el-table-column prop="shopname" label="商铺" align="center"></el-table-column>
                <el-table-column prop="jinlirun" label="净利润（支付）" align="center"></el-table-column>
                <el-table-column prop="guanggaobi" label="广告投放费比" align="center"></el-table-column>
                <el-table-column prop="tuikuailv" label="退款率 %" align="center"></el-table-column>
                <el-table-column prop="maolilv" label="毛利率 %（支付）" align="center">
                </el-table-column>
                <el-table-column prop="yewulirun" label="业务利润（支付）" align="center">
                </el-table-column>
                <el-table-column prop="xiaoshounum" label="销售数量" align="center">
                </el-table-column>
                <el-table-column prop="xiaoshoubizhong" label="销售比重（默认按照全公司销售数量）" align="center">
                </el-table-column>

                <el-table-column prop="pingtaifeilv" label="平台费率 %" align="center">
                </el-table-column>

                <el-table-column prop="kuaidifeibi" label="快递费比（%）" align="center">
                </el-table-column>

                <el-table-column prop="xiaoshoushouru" label="销售收入" align="center">
                </el-table-column>

                <el-table-column prop="shouhoumoney" label="售后金额" align="center">
                </el-table-column>

                <el-table-column prop="shouhoushuliang" label="售后数量" align="center">
                </el-table-column>

                <el-table-column prop="fahuobegintuikuanlv" label="发货前退款率 %（支付）" align="center">
                </el-table-column>

                <el-table-column prop="fahuoendtuikuanlv" label="发货后退款率 %（支付）" align="center">
                </el-table-column>

                <el-table-column prop="xiaoshoushouru" label="销售收入去退（支付）" align="center">
                </el-table-column>

                <el-table-column prop="yewuchengben" label="业务成本（利润）" align="center">
                </el-table-column>

                <el-table-column prop="maolirun" label="毛利润（支付）" align="center">
                </el-table-column>

                <el-table-column prop="xianshangguanggaotoufang" label="线上广告投放费用" align="center">
                </el-table-column>

                <el-table-column prop="pingtaizhangdanfeiyong" label="平台账单费用" align="center">
                </el-table-column>

                <el-table-column prop="kuaidifei" label="快递费" align="center">
                </el-table-column>

                <el-table-column prop="yewulirunlv" label="业务利润率 %（支付）" align="center">
                </el-table-column>

                <el-table-column prop="qitaxiaoshoufeiyong" label="其他费销售费用" align="center">
                </el-table-column>
                <el-table-column prop="jinlirun" label="净利润（支付）" align="center">
                </el-table-column>


                <!-- <el-table-column fixed="right" label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >
              移除
            </el-button>
          </template>
</el-table-column> -->
            </el-table>
            <!-- <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getHetongListFun"
      /> -->
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import * as echarts from "echarts";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import linkboxs from "@/components/linkdata/index";
import DonMessage from "@/utils/message";
export default {
    components: { Pagination, linkboxs },
    data() {
        return {
            dpList: [],
            qudaooptions: [
                { value: "1", label: "淘宝" },
                { value: "2", label: "京东" },
                { value: "3", label: "拼多多" },
            ],
            total: 0,
            listQuery: {
                time: [],
                type: "",
                shopid: "",
            },
            charts: "",
            tableTit: "亏损链接",
            linkList: [
                {
                    tit: "亏损链接",
                    num: "",
                    img: require("../../../../../assets/ym/kslj@2x.png"),
                    height: 105,
                    width: 294,
                },
                {
                    tit: "高推广费率",
                    num: "",
                    img: require("../../../../../assets/ym/gtgl@2x.png"),
                    height: 105,
                    width: 294,
                },
                {
                    tit: "高退款率",
                    num: "",
                    img: require("../../../../../assets/ym/gtkl@2x.png"),
                    height: 105,
                    width: 294,
                },
                {
                    tit: "高毛利低盈利",
                    num: "",
                    img: require("../../../../../assets/ym/gmldyl@2x.png"),
                    height: 105,
                    width: 294,
                },
                {
                    tit: "高转化率亏损",
                    num: "",
                    img: require("../../../../../assets/ym/gzhlks@2x.png"),
                    height: 105,
                    width: 294,
                },
                {
                    tit: "高平台使用费率",
                    num: "",
                    img: require("../../../../../assets/ym/gptsyfl@2x.png"),
                    height: 105,
                    width: 294,
                },
                {
                    tit: "高快递费率",
                    num: "",
                    img: require("../../../../../assets/ym/gkdfl@2x.png"),
                    height: 105,
                    width: 294,
                },
                {
                    tit: "低毛利率",
                    num: "",
                    img: require("../../../../../assets/ym/dmlv@2x.png"),
                    height: 105,
                    width: 294,
                },
                {
                    tit: "高付费高退款",
                    num: "",
                    img: require("../../../../../assets/ym/gffgtk@2x.png"),
                    height: 105,
                    width: 294,
                },
            ],

            userObj: {},
            tableData: [],
        };
    },
    mounted() {
        this.$nextTick(function () {
            //this.drawLine("myChart");
        });
    },
    created() {
        this.getList();
        this.getTb();
        this.getdpListFun();
    },

    methods: {
        linkboxsClick(msg) {
            this.tableData = msg.obj;
            this.tableTit = msg.tit;
            this.$nextTick(function () {
                this.drawLine("myChart", msg.tubiao);
            });
        },
        async getTableList() { },
        async getTb() {
            let params = {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
            };
            const res = await this.$http.post(this.$urls.zongheZhibiaoEchart, params);
            console.log("getTb", res);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            for (let key of this.linkList) {
                if (key.tit == "亏损链接") {
                    key.tubiao = res.kuisunGoodsEcharts;
                }
                if (key.tit == "高推广费率") {
                    key.tubiao = res.tuiguangGoodsEcharts;
                }
                if (key.tit == "高退款率") {
                    key.tubiao = res.tuikuanGoodsEcharts;
                }
                if (key.tit == "高毛利低盈利") {
                    key.tubiao = res.maoliGoodsEcharts;
                }
                if (key.tit == "高转化率亏损") {
                    key.tubiao = res.zhuanhuaGoodsEcharts;
                }
                if (key.tit == "高平台使用费率") {
                    key.tubiao = res.pingtaiGoodsEcharts;
                }
                if (key.tit == "高快递费率") {
                    key.tubiao = res.kuaidiGoodsEcharts;
                }
                if (key.tit == "低毛利率") {
                    key.tubiao = res.dimaoliGoodsEcharts;
                }
                if (key.tit == "高付费高退款") {
                    key.tubiao = res.fufeiGoodsEcharts;
                }
            }
            this.$nextTick(function () {
                this.drawLine("myChart", res.kuisunGoodsEcharts);
            });
        },
        getHetongListFun() { },
        qingchu() {
            this.listQuery = {
                time: [],
                type: "",
                shopid: "",
            };
            this.getList();
        },
        async getList() {
            let params = {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
                starttime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
                endtime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
            };
            const res = await this.$http.post(this.$urls.zongheZhibiao, params);
            console.log("getList1", res);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            for (let key of this.linkList) {
                if (key.tit == "亏损链接") {
                    key.num = res.kuisunGoodsCount;
                    key.obj = res.kuisunGoodsList;
                }
                if (key.tit == "高推广费率") {
                    key.num = res.tuiguangGoodsCount;
                    key.obj = res.tuiguangGoodsList;
                }
                if (key.tit == "高退款率") {
                    key.num = res.tuikuanGoodsCount;
                    key.obj = res.tuikuanGoodsList;
                }
                if (key.tit == "高毛利低盈利") {
                    key.num = res.maoliGoodsCount;
                    key.obj = res.maoliGoodsList;
                }
                if (key.tit == "高转化率亏损") {
                    key.num = res.zhuanhuaGoodsCount;
                    key.obj = res.zhuanhuaGoodsList;
                }
                if (key.tit == "高平台使用费率") {
                    key.num = res.pingtaiGoodsCount;
                    key.obj = res.pingtaiGoodsList;
                }
                if (key.tit == "高快递费率") {
                    key.num = res.kuaidiGoodsCount;
                    key.obj = res.kuaidiGoodsList;
                }
                if (key.tit == "低毛利率") {
                    key.num = res.dimaoliGoodsCount;
                    key.obj = res.dimaoliGoodsList;
                }
                if (key.tit == "高付费高退款") {
                    key.num = res.fufeiGoodsCount;
                    key.obj = res.fufeiGoodsList;
                }
                this.tableData = res.kuisunGoodsList;
            }
        },
        // 店铺列表
        async getdpListFun() {
            const res = await this.$http.get(this.$urls.getshoplist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dpList = res.list;
        },
        drawLine(id, item) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption({
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: [""],
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "12%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: item.x,
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        name: "近七日",
                        type: "line",
                        stack: "总量",
                        data: item.y,
                    },
                ],
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#myChart {
    width: 1508px;
    height: 300px;
}

.home_links {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 20px;

    .home_item {
        height: 105px;
        margin-bottom: 26px;
        margin-right: 13px;
        background-size: 294px 105px;
        padding: 25px;

        .home_item_t1 {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 19px;
            color: #232323;
        }

        .home_item_t2 {
            font-family: PingFang SC;
            font-weight: 800;
            font-size: 27px;
            color: #232323;
        }

        &:nth-of-type(5n) {
            margin-right: 0;
        }
    }
}

.home_title {
    width: 100%;
    height: 55px;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .home_tit {
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 26px;
        color: #232323;
    }

    .home_right {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;

        .home_right_2 {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            margin-left: 10px;
        }

        .home_right_1 {
            padding: 0 10px;
            width: 108px;
            height: 45px;
            background: #f4f5f9;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
        }
    }
}

.shaixuan_btns {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;

    .shaixuan_btn1 {
        width: 132px;
        height: 55px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #999999;
        text-align: center;
        line-height: 55px;
    }

    .shaixuan_btn2 {
        margin-left: 25px;
        width: 131px;
        height: 54px;
        background: #195cf8;
        border-radius: 10px;
        text-align: center;
        line-height: 55px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
    }
}

.cont_wrapper {
    padding: 25px;

    .cont_wrapper_sx {
        width: 1527px;
        height: 71px;
        background: #f5f5f5;
        border-radius: 10px;
        padding: 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .shaixuan_left {
            display: flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
        }

        .shaixuan_item {
            width: 350px;
            height: 54px;
            background: #ffffff;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            margin-right: 22px;

            .shaixuan_item_con {
                display: flex;
                flex-direction: row;
                justify-content: start;
                align-items: center;

                .shaixuan_item_tit {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #232323;
                }

                .shaixuan_item_sel {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #999999;
                }

                .shaixuan_item_arr {
                    width: 13px;
                    height: 8px;
                    margin-left: 10px;
                }

                .shaixuan_item_icon {
                    width: 29px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
        }
    }
}

.shaixuan_item {
    /deep/ .el-date-editor {
        border: none !important;
        text-align: right;
        font-size: 18px;
        width: 196px;
    }

    /deep/ .el-input__icon {
        display: none;
    }

    .el-input /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }

    .el-input /deep/.el-input__prefix {
        display: none !important;
    }

    .el-select /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/dashboard/dashboardcompre/index.vue